import { useGetChatByEntityQuery } from "../api"

export const MAX_SHOWN_UNREAD_COUNT = 99

type UseEntityChatUnreadCountParams = {
  type: "project" | "task"
  entityId: string
  skip?: boolean
}

// The chat:updated socket event (SocketManager) invalidates the Chat tag, and so
// does markChatAsRead, so this count refreshes on new messages and clears itself
// once the chat is opened.
export const useEntityChatUnreadCount = ({ type, entityId, skip }: UseEntityChatUnreadCountParams) => {
  const { data: chat } = useGetChatByEntityQuery({ type, entityId }, { skip })
  return chat?.unreadCount ?? 0
}
